"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionList = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const react_2 = require("react");
const __1 = require("..");
const Accordion_1 = require("./Accordion");
function AccordionList(props) {
    const { accordions, size, allowMultipleExpanded = true, compact = false } = props;
    const [expandedIndex, setExpandedIndex] = (0, react_2.useState)(accordions.findIndex((a) => a.defaultExpanded));
    const tid = (0, __1.useTestIds)(props, "accordionList");
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: accordions.map((accordionProps, index, arr) => ((0, react_1.createElement)(Accordion_1.Accordion, { ...accordionProps, ...tid, compact: compact, key: index, size: size, bottomBorder: compact ? false : index === arr.length - 1, defaultExpanded: !allowMultipleExpanded && expandedIndex === index, index: index, setExpandedIndex: setExpandedIndex }))) }));
}
exports.AccordionList = AccordionList;
